import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
  Grid,
  Tooltip,
  TextField,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Breadcrumbs,
  Link,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import {
  Notifications,
  CalendarToday,
  Search,
  Home,
  ArrowBackIos,
} from "@mui/icons-material";
import { InfoOutlined } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { VendorappBar } from "../../components";
import { useSelector } from "react-redux";
import AgentAssignment from "./AgentAssignment";
import { useFetch } from "../../hooks";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";

const statusColors = {
  "Pending": "#FFF4E6",
  "PENDING": "#FFF4E6",
  "Rejected": "#FFE5E5",
  "REJECTED": "#FFE5E5",
  "Agent Assigned": "#E8F5E9",
  "ACCEPTED": "#E8F5E9",
  "Picked": "#E3F2FD",
  "Shipped": "#F3E5F5",
  "Delivered": "#E8F5E9",
  "Cancelled": "#FFEBEE",
};

const statusTextColors = {
  "Pending": "#F57C00",
  "PENDING": "#F57C00",
  "Rejected": "#D32F2F",
  "REJECTED": "#D32F2F",
  "Agent Assigned": "#2E7D32",
  "ACCEPTED": "#2E7D32",
  "Picked": "#1976D2",
  "Shipped": "#7B1FA2",
  "Delivered": "#388E3C",
  "Cancelled": "#C62828",
};

const progressData = [
  {
    status: "Order Placed",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "2:00 pm",
  },
  {
    status: "Documentation Prepared",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "3:30 pm",
  },
  {
    status: "Booking Arranged",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "3:35 pm",
  },
  {
    status: "Collected",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "4:00 pm",
  },
  {
    status: "In Transit to Destination",
    location: "New York, USA",
    date: "August 29, 2020",
    time: "6:00 pm",
  },
  {
    status: "Arrived at Destination",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
  {
    status: "Out for Delivery",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
  {
    status: "Delivered",
    location: "London, United Kingdom",
    date: "",
    time: "",
  },
];

export default function Adminlistingorder({ onBackScreenName }) {
  const [mainTab, setMainTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [status, setStatus] = useState("");
  const [trackingNumber, setTrackingNumber] = useState("");
  const [orderData, setOrderData] = useState([]);
  const [isOrderModalOpen, setOrderModalOpen] = useState(false);
  const [isAgentAssignmentOpen, setAgentAssignmentOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user.userdetails);
  const userVtype = userDetails?.vtype;
  const loginToken = useSelector((state) => state.user.logintoken);
  console.log("userVtype", userVtype);

  // Initialize useFetch hook for getAllOrders API (SITE ADMIN tab)
  const {
    data: ordersApiData,
    error: ordersApiError,
    isLoading: ordersApiLoading,
    fetchData: fetchOrdersData,
  } = useFetch(BASE_URL_TEST + urls("getAllOrders"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Initialize useFetch hook for fetchOrderStatus API (other tabs)
  const {
    data: orderStatusData,
    error: orderStatusError,
    isLoading: orderStatusLoading,
    fetchData: fetchOrderStatusData,
  } = useFetch(BASE_URL_TEST + urls("fetchOrderStatus"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  // Fetch orders based on selected tab
  useEffect(() => {
    setLoading(true);

    if (selectedTab === 0) {
      // SITE ADMIN tab - use getAllOrders
      fetchOrdersData({
        type: "admin",
        vendor_id: userDetails?.id || "0",
      });
    } else {
      // Other tabs - use fetchOrderStatus
      const statusMap = {
        1: "ACCEPTED",
        2: "Picked",
        3: "Shipped",
        4: "Delivered",
        5: "Rejected"
      };

      const orderStatus = statusMap[selectedTab];
      if (orderStatus) {
        fetchOrderStatusData({
          type: "admin",
          vendor_id: userDetails?.id || "0",
          order_status: orderStatus
        });
      }
    }
  }, [selectedTab]);

  // Handle API response
  useEffect(() => {
    if (ordersApiError) {
      console.error("Error fetching orders:", ordersApiError);
      setLoading(false);
    } else if (ordersApiData && ordersApiData.status === true) {
      console.log("Orders data received:", ordersApiData.data);

      // Helper function to format date
     const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

      // Transform API data to match component structure
      const transformedData = ordersApiData.data?.map((order) => ({
        // Original API fields
        ...order,

        // Mapped fields for backward compatibility
        id: order.cartDetails?.cart_number,
        cart_number: order.cartDetails?.cart_number,
        created: formatDate(order.createdAt),
        customer: order.cartDetails?.customerDetails
          ? `${order.cartDetails.customerDetails.first_name || ""} ${order.cartDetails.customerDetails.last_name || ""}`.trim()
          : "N/A",
        total: order.cartDetails?.cart_total_amount
          ? `₹${order.cartDetails.cart_total_amount}`
          : "N/A",
        total_amount: order.cartDetails?.cart_total_amount
          ? `₹${order.cartDetails.cart_total_amount}`
          : "N/A",
        status: order.order_status,
        trackingNumber: order.cartDetails?.transaction_id,
        agentName: order.agentDetails?.first_name && order.agentDetails?.last_name
          ? `${order.agentDetails.first_name} ${order.agentDetails.last_name}`.trim()
          : null,
        agentPhone: order.agentDetails?.phone_number || null,
        city: order.cartDetails?.customerDetails?.city ||
              order.cartDetails?.vendors?.[0]?.vendorDetails?.city ||
              "N/A",
      // In both transformedData mappings (ordersApiData and orderStatusData useEffects)

varientName: (() => {
  const vendors = order.cartDetails?.vendors || order.cart?.vendors || [];
  const allItemNames = vendors.flatMap((vendor) =>
    (vendor.items || []).map((item) => item?.product?.name).filter(Boolean)
  );
  return allItemNames.length > 0 ? allItemNames.join(", ") : "N/A";
})(),  // Keep nested structure for detailed view
        cart: order.cartDetails,
      })) || [];

      setOrderData(transformedData);
      setLoading(false);
    } else if (ordersApiData && ordersApiData.status === false) {
      console.log("No orders found:", ordersApiData.message);
      setOrderData([]);
      setLoading(false);
    }
  }, [ordersApiData, ordersApiError]);

  // Handle orderStatusData API response
  useEffect(() => {
    if (orderStatusError) {
      console.error("Error fetching order status data:", orderStatusError);
      setLoading(false);
    } else if (orderStatusData) {
      console.log("Order status data received:", orderStatusData);

      // Check if data exists (response structure has "status": "ordersList")
      if (orderStatusData.data && Array.isArray(orderStatusData.data)) {
        // Helper function to format date
        // Place this above both useEffects, as a standalone function inside the component
const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Then in both useEffects, remove the local formatDate definition
// and just use the shared one above

        // Transform API data to match component structure
        const transformedData = orderStatusData.data.map((order) => ({
          // Original API fields
          ...order,

          // Mapped fields for backward compatibility
          id: order.cartDetails?.cart_number,
          cart_number: order.cartDetails?.cart_number,
          created: formatDate(order.createdAt),
          customer: order.cartDetails?.customerDetails
            ? `${order.cartDetails.customerDetails.first_name || ""} ${order.cartDetails.customerDetails.last_name || ""}`.trim()
            : "N/A",
          total: order.cartDetails?.cart_total_amount
            ? `₹${order.cartDetails.cart_total_amount}`
            : "N/A",
          total_amount: order.cartDetails?.cart_total_amount
            ? `₹${order.cartDetails.cart_total_amount}`
            : "N/A",
          status: order.order_status,
          trackingNumber: order.cartDetails?.transaction_id,
          agentName: order.agentDetails?.first_name && order.agentDetails?.last_name
            ? `${order.agentDetails.first_name} ${order.agentDetails.last_name}`.trim()
            : null,
          agentPhone: order.agentDetails?.phone_number || null,
          city: order.cartDetails?.customerDetails?.city ||
                order.cartDetails?.vendors?.[0]?.vendorDetails?.city ||
                "N/A",
         // In both transformedData mappings (ordersApiData and orderStatusData useEffects)

varientName: (() => {
  const vendors = order.cartDetails?.vendors || order.cart?.vendors || [];
  const allItemNames = vendors.flatMap((vendor) =>
    (vendor.items || []).map((item) => item?.product?.name).filter(Boolean)
  );
  return allItemNames.length > 0 ? allItemNames.join(", ") : "N/A";
})(), // Keep nested structure for detailed view
          cart: order.cartDetails,
        }));

        setOrderData(transformedData);
        setLoading(false);
      } else {
        console.log("No order status data found");
        setOrderData([]);
        setLoading(false);
      }
    }
  }, [orderStatusData, orderStatusError]);

  const handleEditClick = (order) => {
    setSelectedOrder(order);
    setTrackingNumber(order.trackingNumber);
    setStatus(order.status);
    setOrderModalOpen(true);
  };

  const handleModalClose = () => {
    setOrderModalOpen(false);
    setSelectedOrder(null);
  };

  const handleAssignAgentClick = () => {
    // Don't close the order details modal, just open agent assignment
    setAgentAssignmentOpen(true);
  };

  const handleAgentAssignmentClose = () => {
    setAgentAssignmentOpen(false);
    // Keep the order details modal open
  };

  const handleAgentAssign = (agent) => {
    const orderId = selectedOrder.id || selectedOrder.cart_number;
    const agentAssignId = selectedOrder.agent_assign_id;

    // Update the order with assigned agent
    const updatedOrders = orderData.map((order) => {
      const currentOrderId = order.id || order.cart_number;
      return currentOrderId === orderId
        ? {
            ...order,
            agentName: agent.agentName,
            agentPhone: agent.phoneNo,
            status: "Agent Assigned",
            order_status: "Agent Assigned",
            agent_id: agent.agent_id,
            agent_assign_id: agentAssignId || agent.agent_id, // Set agent_assign_id for status display
            delivery_agent_id: agent.agent_id, // Also set delivery_agent_id
            agentDetails: {
              ...order.agentDetails,
              agent_id: agent.agent_id,
              first_name: agent.agentName?.split(' ')[0],
              last_name: agent.agentName?.split(' ')[1] || '',
              phone_number: agent.phoneNo,
            },
          }
        : order;
    });
    setOrderData(updatedOrders);

    // Update selected order
    setSelectedOrder({
      ...selectedOrder,
      agentName: agent.agentName,
      agentPhone: agent.phoneNo,
      status: "Agent Assigned",
      order_status: "Agent Assigned",
      agent_id: agent.agent_id,
      agent_assign_id: agentAssignId || agent.agent_id, // Set agent_assign_id for status display
      delivery_agent_id: agent.agent_id, // Also set delivery_agent_id
      agentDetails: {
        ...selectedOrder.agentDetails,
        agent_id: agent.agent_id,
        first_name: agent.agentName?.split(' ')[0],
        last_name: agent.agentName?.split(' ')[1] || '',
        phone_number: agent.phoneNo,
      },
    });

    // TODO: Call API to save assignment
    console.log("Agent assigned:", agent, "to order:", orderId, "agent_assign_id:", agentAssignId);

    // Show success message with snackbar
    setSnackbarMessage(`Agent ${agent.agentName} successfully assigned to order ${orderId}`);
    setSnackbarSeverity("success");
    setSnackbarOpen(true);

    // Close the agent assignment dialog
    handleAgentAssignmentClose();

    // Close the order details modal and return to Site Admin table
    handleModalClose();
  };

  const handleBackClick = () => {
    if (onBackScreenName) {
      onBackScreenName("Dashboard");
    } else {
      navigate(-1);
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredOrders = orderData.filter((order) =>
    order?.id?.toString().toLowerCase().includes(searchValue.toLowerCase()) ||
    order?.cart_number?.toString().toLowerCase().includes(searchValue.toLowerCase())
  );
  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 0,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
      
     

        <Box
          component="main"
          sx={{ flexGrow: 1, bgcolor: "#EEF2FF", overflowY: "auto" }}
        >
          <Tabs value={selectedTab} onChange={handleTabChange} sx={{ mb: 2 }}>
            <Tab
              label="Site Admin"
              sx={{ color: selectedTab === 0 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Accepted"
              sx={{ color: selectedTab === 1 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Picked"
              sx={{ color: selectedTab === 2 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Shipped"
              sx={{ color: selectedTab === 3 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Delivered"
              sx={{ color: selectedTab === 4 ? "#4F46E5" : "inherit" }}
            />
            <Tab
              label="Cancelled"
              sx={{ color: selectedTab === 5 ? "#4F46E5" : "inherit" }}
            />
          </Tabs>

          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <TextField
              placeholder="Search by order id"
              variant="outlined"
              size="small"
              value={searchValue}
              onChange={handleSearchChange}
              sx={{ width: "300px" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* Orders Table */}
          {ordersApiError && (
            <Box sx={{ mb: 2, p: 2, bgcolor: "#ffebee", borderRadius: 1 }}>
              <Typography color="error">
                Error loading orders: {ordersApiError.message || "Please try again"}
              </Typography>
            </Box>
          )}
          <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }}>ORDER ID</TableCell>
                  {/* <TableCell>TRACKING NUMBER</TableCell> */}
                  <TableCell sx={{ fontWeight: "bold" }}>CREATED</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>CUSTOMER</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>TOTAL</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>PROFIT</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>ORDER STATUS</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }}>AGENT STATUS</TableCell>
                  <TableCell align="right" sx={{ fontWeight: "bold" }}>
                    ACTIONS
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading || ordersApiLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                      <CircularProgress />
                      <Typography sx={{ mt: 2 }}>Loading orders...</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredOrders.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 5 }}>
                      <Typography>No orders found</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredOrders.map((order, index) => (
                  <TableRow key={index}>
                    <TableCell>{order.id || order.cart_number || "N/A"}</TableCell>
                    {/* <TableCell>{order.trackingNumber}</TableCell> */}
                    <TableCell>
                      {order.created || order.cart?.created_at || "N/A"}
                    </TableCell>
                    <TableCell>
                      {order.customer ||
                       (order.cart?.customerDetails ?
                         `${order.cart.customerDetails.first_name || ""} ${order.cart.customerDetails.last_name || ""}`.trim()
                         : "N/A")}
                    </TableCell>
                    <TableCell>{order.total || order.total_amount || "N/A"}</TableCell>
                    <TableCell>
                      {order.profit || "N/A"}
                      {order.profitPercent && (
                        <Box
                          component="span"
                          sx={{
                            backgroundColor: "rgba(76, 175, 80, 0.2)",
                            borderRadius: "10px",
                            padding: "2px 8px",
                            color: "#4CAF50",
                            fontWeight: "bold",
                            display: "inline-block",
                            ml: 1,
                          }}
                        >
                          {order.profitPercent}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      <Typography
                        sx={{
                          backgroundColor: statusColors[order.status || order.order_status] || "rgba(158, 158, 158, 0.2)",
                          borderRadius: "10px",
                          padding: "4px 12px",
                          color: statusTextColors[order.status || order.order_status] || "#757575",
                          fontWeight: "bold",
                          display: "inline-block",
                        }}
                      >
                        {order.status || order.order_status || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {(order?.agentDetails?.first_name && order?.agentDetails?.phone_number) ||
                       (order?.agentName && order?.agentPhone) ? (
                        <Typography
                          sx={{
                            backgroundColor: "rgba(76, 175, 80, 0.2)",
                            borderRadius: "10px",
                            padding: "4px 12px",
                            color: "#4CAF50",
                            fontWeight: "bold",
                            display: "inline-block",
                          }}
                        >
                          Assigned
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            backgroundColor: "rgba(158, 158, 158, 0.2)",
                            borderRadius: "10px",
                            padding: "4px 12px",
                            color: "#9E9E9E",
                            fontWeight: "bold",
                            display: "inline-block",
                          }}
                        >
                          Not Assigned
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="right">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                        onClick={() => setOpen(true)}
                      >
                        {/* View Icon with navigation */}
                        <VisibilityIcon
                          onClick={() => handleEditClick(order)}
                          style={{ cursor: "pointer" }}
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Typography variant="body2">
              Showing {filteredOrders.length} of {orderData.length}
            </Typography>
            <Box>
              <IconButton sx={{ color: "#4F46E5" }}>⟨</IconButton>
              {[1, 2, 3, 4, 5].map((page) => (
                <IconButton key={page} sx={{ color: "#4F46E5" }}>
                  {page}
                </IconButton>
              ))}
              <IconButton sx={{ color: "#4F46E5" }}>⟩</IconButton>
            </Box>
          </Box>
        </Box>

        {/* Order Details Modal */}
        <Dialog
          open={isOrderModalOpen}
          onClose={handleModalClose}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Order Details
            <IconButton
              onClick={handleModalClose}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              ×
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            {selectedOrder && (
              <Box>
                {/* Vendor Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    mb: 3,
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Vendor Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Shop Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.shop_name ||
                         selectedOrder.cart?.vendors?.[0]?.vendorDetails?.shop_name ||
                         "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Vendor ID
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.vendor_id ||
                         selectedOrder.cart?.vendors?.[0]?.vendorDetails?.vendor_id ||
                         "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Phone Number
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.phone_number ||
                         selectedOrder.cart?.vendors?.[0]?.vendorDetails?.phone_number ||
                         "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Email
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.email ||
                         selectedOrder.cart?.vendors?.[0]?.vendorDetails?.email ||
                         "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">
                        Location
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.location ||
                         selectedOrder.cart?.vendors?.[0]?.vendorDetails?.location ||
                         "N/A"}
                        {(selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.city ||
                          selectedOrder.cart?.vendors?.[0]?.vendorDetails?.city) &&
                          `, ${selectedOrder.cartDetails?.vendors?.[0]?.vendorDetails?.city ||
                               selectedOrder.cart?.vendors?.[0]?.vendorDetails?.city}`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* Order Details Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    mb: 3,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Order Details
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Order ID
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.id || selectedOrder.cart_number || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Customer Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.customer ||
                         (selectedOrder.cart?.customerDetails ?
                           `${selectedOrder.cart.customerDetails.first_name || ""} ${selectedOrder.cart.customerDetails.last_name || ""}`.trim()
                           : "N/A")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Total Amount
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.total || selectedOrder.total_amount || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Tracking Number
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.trackingNumber || selectedOrder.cart?.transaction_id || "N/A"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* Agent Details Section */}
<Box
  sx={{
    border: "1px solid #e0e0e0",
    borderRadius: 2,
    padding: 2,
    mt: 3,
    backgroundColor: "#f9f9f9",
  }}
>
  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
    Agent Details
  </Typography>

  {selectedOrder?.agentDetails?.agent_id ? (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Agent Name
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {`${selectedOrder.agentDetails.first_name || ""} ${selectedOrder.agentDetails.last_name || ""}`.trim() || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Agent ID
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.agent_id || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Phone Number
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.phone_number || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Email
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.email || "N/A"}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Location
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.location || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Status
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            color:
              selectedOrder.agentDetails.status === "busy"
                ? "orange"
                : selectedOrder.agentDetails.status === "available"
                ? "green"
                : "red",
            textTransform: "capitalize",
          }}
        >
          {selectedOrder.agentDetails.status || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          License Number
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.license_number || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography variant="body2" color="textSecondary">
          Bike Number
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {selectedOrder.agentDetails.bike_number || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          Address
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          {[
            selectedOrder.agentDetails.street,
            selectedOrder.agentDetails.landmark,
            selectedOrder.agentDetails.city,
            selectedOrder.agentDetails.state,
            selectedOrder.agentDetails.pincode,
          ]
            .filter(Boolean)
            .join(", ") || "N/A"}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: 3,
        backgroundColor: "rgba(158,158,158,0.1)",
        borderRadius: 2,
      }}
    >
      <Typography variant="body1" sx={{ color: "#9E9E9E", fontWeight: "bold" }}>
        No Agent Assigned Yet
      </Typography>
    </Box>
  )}
</Box>


                {/* Status Section */}
                <Box
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    padding: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography variant="h6" sx={{ mb: 2, color: "#3f51b5" }}>
                    Status Information
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Customer Name
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.customer ||
                         (selectedOrder.cart?.customerDetails ?
                           `${selectedOrder.cart.customerDetails.first_name || ""} ${selectedOrder.cart.customerDetails.last_name || ""}`.trim()
                           : "N/A")}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        City
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.city || "N/A"}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Created
                      </Typography>
                      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                        {selectedOrder.created || selectedOrder.cart?.created_at || "N/A"}
                      </Typography>
                    </Grid>
                   <Grid item xs={6}>
  <Typography variant="body2" color="textSecondary">
    Variant Name
  </Typography>
  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
    {selectedOrder.varientName !== "N/A"
      ? selectedOrder.varientName.split(", ").map((name, i) => (
          <Box key={i} component="span" sx={{ display: "block" }}>
            {i + 1}. {name}
          </Box>
        ))
      : "N/A"}
  </Typography>
</Grid>
                  </Grid>
                </Box>
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={handleModalClose} variant="outlined" color="inherit">
              Close
            </Button>
            {selectedTab === 0 && (
              <Button onClick={handleAssignAgentClick} variant="contained" color="primary">
                Assign Agent
              </Button>
            )}
          </DialogActions>
        </Dialog>

        {/* Agent Assignment Dialog */}
        <AgentAssignment
          open={isAgentAssignmentOpen}
          onClose={handleAgentAssignmentClose}
          orderId={selectedOrder?.id}
          agentAssignId={selectedOrder?.agent_assign_id}
          onAssign={handleAgentAssign}
        />

        {/* Success Snackbar */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            variant="filled"
            sx={{
              width: '100%',
              fontSize: '16px',
              fontWeight: 'bold',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
            }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}
